import type { CustomerPlItem } from '@/models/customerPl';
import i18n from '@/plugins/i18n';
import type { CustomerPlSection } from '@/types/customerPl';
import type { DataTableHeader } from '@/types/vuetify';
import { resolveCustomerPlDisplayName } from './resolveCustomerPlDisplayName';

export function createCustomerPlTableHeaders(nameTitleKey = 'customerPl.name', section: CustomerPlSection = 'total'): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: t(nameTitleKey),
            value: (item) => resolveCustomerPlDisplayName(item as CustomerPlItem, section),
            key: 'name',
            align: 'start',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('customerPl.totalBets'),
            value: 'settledBetCount',
            key: 'settledBetCount',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('customerPl.totalStake'),
            value: 'settledStakeSum',
            key: 'settledStakeSum',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('customerPl.totalPl'),
            value: 'balance',
            key: 'balance',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('customerPl.roi'),
            value: 'roi',
            key: 'roi',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('customerPl.lastBet'),
            value: (item) => {
                const lastBetAt = (item as CustomerPlItem).lastBetAt;
                return lastBetAt ? new Date(lastBetAt).getTime() : 0;
            },
            key: 'lastBetElapsed',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('customerPl.avgStake'),
            value: 'avgStake',
            key: 'avgStake',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('customerPl.avgBetVsOpen'),
            value: (item) => (item as CustomerPlItem).oddsOpenAvg ?? Number.NEGATIVE_INFINITY,
            key: 'avgBetVsOpen',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('customerPl.avgBetVsClose'),
            value: (item) => (item as CustomerPlItem).oddsCloseAvg ?? Number.NEGATIVE_INFINITY,
            key: 'avgBetVsClose',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('customerPl.pc'),
            value: (item) => {
                const row = item as CustomerPlItem;
                return row.settledBetCount ? row.settledPcBetCount / row.settledBetCount : 0;
            },
            key: 'pcPercent',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
        {
            title: t('customerPl.mobile'),
            value: (item) => {
                const row = item as CustomerPlItem;
                return row.settledBetCount ? row.settledMobileBetCount / row.settledBetCount : 0;
            },
            key: 'mobilePercent',
            align: 'end',
            sortable: true,
            nowrap: true,
        },
    ];
}
